import { Carousel, Toast, Modal, Tooltip, Popover } from "bootstrap";
import { TwoFactorInputManager } from "./otp";
import { PasswordValidator, PasswordOptions } from './password-validator' 

export interface SignInResult {
    succeeded: boolean;
    requiresTwoFactor?: boolean;
    requiresCustomer?: boolean;
    nextStepUrl?: string;
    errorUrl?: string;
    error?: any;
    errors?: ValidationError[];
}

interface ErrorDetail {
    errorMessage: string;
    exception?: any; // Peut être null
}

interface ErrorValue {
    $id: string;
    $values: ErrorDetail[];
}

interface ValidationError {
    key: string;
    value: {
        errors: ErrorValue;
        rawValue?: string;
        attemptedValue?: string;
        validationState?: number;
        isContainerNode?: boolean;
        children?: any;
    };
}

export interface SignInOptions {
    returnUrl?: string;
}

export interface SignInManagerOptions {
    containerId: string;        
}

export class Task {
    public static async delay(ms: number): Promise<void> {
        return new Promise(resolve => {
            setTimeout(resolve, ms);
        });
    }
}

class IdentityOptions {
    public static requireConfirmedEmail = true;
    public static requireConfirmedAccount = false;
    public static requireConfirmedPhoneNumber = false;
} 

class IdentityEndPoints {
    public static get SignIn(): string {
        return `/${document.documentElement.lang}/Account/SignIn`;
    }
    public static get TwoFactorSignIn(): string {
        return `/${document.documentElement.lang}/Account/TwoFactorSignIn`;
    }

    public static get CustomerSignIn(): string {
        return `/${document.documentElement.lang}/Account/CustomerSignIn`;
    }

    public static get SignUp(): string {
        return `/${document.documentElement.lang}/Account/SignUp`;
    }
    public static get ForgotPassword(): string {
        return `/${document.documentElement.lang}/Account/ForgotPassword`;
    }


}
export class SignInManager {
    private _options: SignInManagerOptions;
    private _currentForm?: HTMLFormElement;
    private _identityOptions: IdentityOptions = {
        requiredLength: 6,
        requiredUniqueChars: 1,
        requireUppercase: true,
        requireLowercase: true,
        requireDigit: true,
        requireNonAlphanumeric: true
    };

    private returnUrl: string;
    private _passwordValidator: PasswordValidator;

    public get passwordValidator(): PasswordValidator {
        return this._passwordValidator;
    }

    public static get instance(): SignInManager {
        return signInManager;
    }
    get container(): HTMLElement {
        return document.getElementById(this._options.containerId)!;
    }
    get carousel(): Carousel {
        if (this.container != null) {
            return new Carousel(this.container);
        }
        return null;
    }
    get carouselItems(): NodeListOf<HTMLElement> {
        return this.container.querySelector(".carousel-inner").querySelectorAll(".carousel-item") ;
    }

    get lang(): string { return document.documentElement.lang || 'en'; }
    get loginUrl(): string { return `/${this.lang}/Account/SignIn`; }

    private get loadingTemplate(): HTMLTemplateElement {
        return document.getElementById("loading-template") as HTMLTemplateElement;
    }
    private get successTemplate(): HTMLTemplateElement {
        return document.getElementById("success-template") as HTMLTemplateElement;
    }
    private get errorTemplate(): HTMLTemplateElement {
        return document.getElementById("error-template") as HTMLTemplateElement;
    }
    private get itemTemplate(): HTMLTemplateElement {
        return document.getElementById("item-template") as HTMLTemplateElement;
    }

    constructor(containerId: string) {

        // Écouter l'événement personnalisé signInFormLoaded
        document.addEventListener('signInFormLoaded', (event: CustomEvent) => {
            const form = event.detail.form as HTMLFormElement;
            if (!form) {
                console.error('Aucun formulaire fourni dans signInFormLoaded.');
                return;
            }

            this._passwordValidator = new PasswordValidator(form, {
                passwordSelector: '#Password',
                rules: "#password-rules",
                confirmPasswordSelector: "#ConfirmPassword"                
            });            
        });

        this._options = {
            containerId,
            
        };
         

        window.onload = function () {
            var loginDone = sessionStorage.getItem("loginDone");
            if (loginDone) {
                var toast = Toast.getOrCreateInstance($('#loginDone')[0]);
                toast.show();
                sessionStorage.removeItem("loginDone");
            }
        }

    }
     

    public async signIn(options?: SignInOptions): Promise<void> {
        return new Promise(async (resolve, reject) => {

            

            if (options != null) {
                this.returnUrl = options.returnUrl;
            } else {
                this.returnUrl = null;
            }

            await this.reset();

            $('#btnSignIn').addClass('d-none');
            $('#btnSignUp').removeClass('d-none');
            $('#btnForgotPassword').removeClass('d-none');

            $('#loginModal').modal('show');

            await this.loadUrl(IdentityEndPoints.SignIn);
                
            resolve();
        });
    }

    public async signUp(options: SignInOptions): Promise<void> {
        return new Promise(async (resolve, reject) => {
            if (options != null) {
                this.returnUrl = options.returnUrl;
            } else {
                this.returnUrl = null;
            }

            await this.reset();
            //await this.startLoading();


            $('#btnSignIn').removeClass('d-none');
            $('#btnSignUp').addClass('d-none');
            $('#btnForgotPassword').removeClass('d-none');

            $('#loginModal').modal('show');

            await this.loadUrl(IdentityEndPoints.SignUp);


            
           
            resolve();
        });
    }

    public async forgotPassword(options?: SignInOptions): Promise<void> {
        return new Promise(async (resolve, reject) => {


            if (options != null) {
                this.returnUrl = options.returnUrl;
            } else {
                this.returnUrl = null;
            }

            await this.reset(); //await this.startLoading();
            $('#btnSignIn').removeClass('d-none');
            $('#btnSignUp').removeClass('d-none');
            $('#btnForgotPassword').addClass('d-none');
            $('#loginModal').modal('show');

            //var el = await this.loadTemplate(this.signInTemplate);
            await this.loadUrl(IdentityEndPoints.ForgotPassword);
            

        });
    }


    public async twoFactorPinCode(): Promise<TwoFactorInputManager> {

        return new Promise((resolve, reject) => {
            const _ = this;
            

            const otp = new TwoFactorInputManager({
                containerSelector: ".pinCodeContainer",
                verifyFunctionHandler: async function (code) {
                    //$('input[type=hidden][name=Token]').val(code);

                    const loadingElement = await _.startLoading();
                    $('#twoFactorValidationErrorMessage').hide();
                    const rememberThisDevice = $('#RememberThisDevice').prop("checked");

                    $.post({
                        url: IdentityEndPoints.TwoFactorSignIn,
                        data: {
                            Token: code,
                            RememberThisDevice: rememberThisDevice
                        }
                    }).then(async twoFactorVerif => {

                            if (twoFactorVerif.succeeded) {
                                //alert('connexion reussie');
                                _.container.querySelector(".carousel-inner").querySelectorAll(".carousel-item:not(.active)").forEach(o => o.remove());
                                loadingElement.querySelector(".text-success").classList.remove("d-none");
                                loadingElement.querySelector(".spinner-grow").classList.add("d-none");
                                await Task.delay(1000);
                            }
                            $('#twoFactorValidationErrorMessage').show();
                            await _.onSignInResult(twoFactorVerif, _._currentForm);
                            
                            //if (twoFactorVerif.nextStepUrl) {
                            //    await Task.delay(1000);
                            //    await _.loadStep(twoFactorVerif.nextStepUrl);

                            //}                            
                        }).catch(async err => {
                            loadingElement.querySelector(".text-danger").classList.remove("d-none");
                            loadingElement.querySelector(".spinner-grow").classList.add("d-none");
                            await Task.delay(3000);
                            _.reset();
                            reject(err);
                            return;
                        });

                    //$('input[type=hidden][name=Token]').closest('form').submit();
                }
            });
            resolve(otp);
        });
    }

    public async twoFactorSignInGet(): Promise<void> {
        return new Promise<void>(async (resolve, reject) => {
            await this.loadUrl(IdentityEndPoints.TwoFactorSignIn);            
            resolve();
        });
    }

    public alert(err) {
        alert(err);
    }


    private createCarouselItem(content: string): string {
        return `<div class='carousel-item'>${content}</div>`;
    }

    

    private async startLoading(): Promise<HTMLElement> {


        return new Promise((resolve, reject) => {
            const _ = this;
            const container = this.container;// document.getElementById("loginBodyContainer");
            const carousel = this.carousel;
            const loadingTemplate = this.loadingTemplate;

            const carouselInner = container.querySelector('.carousel-inner');
            const nouvelElement = $(loadingTemplate.innerHTML)[0];// loadingTemplate.content.cloneNode(true) as HTMLElement;            
            const currentElement = container.querySelector(".courousel-item.active");

            carouselInner.appendChild(nouvelElement);

            if (currentElement != null) {

                nouvelElement.style.minHeight = currentElement.clientHeight.toString();

            } else {
                nouvelElement.style.minHeight = '100%';
            }

            $(this.container).one('slid.bs.carousel', function () {
                resolve(nouvelElement);
            });

            carousel.next();

        });

    }

    private async successStep() {

    }

    private async reset(): Promise<void> {
        return new Promise((resolve, reject) => {
            try {
                 
                var items = this.container.querySelectorAll(".carousel-item");

                items.forEach((item, index) => {
                    if (index !== 0)
                        item.remove(); // Supprimer l'élément

                });
                items.item(0).classList.add('active');
                resolve();
            } catch (e) {
                reject(e);
            }
        });
    }
    private async clearStep(): Promise<void> {
        this.container.querySelector(".carousel-inner").querySelectorAll(".carousel-item:not(.active)").forEach(o => o.remove());
    }

    //private get signInTemplate(): HTMLTemplateElement {
    //    return document.getElementById("SignInTemplate") as HTMLTemplateElement;
    //}
    //private get twoFactorTemplate(): HTMLTemplateElement {
    //    return document.getElementById("TwoFactorTemplate") as HTMLTemplateElement;
    //}
    //private get customersTemlate(): HTMLTemplateElement {
    //    return document.getElementById("CustomersTemplate") as HTMLTemplateElement;
    //}
    //private get signUpTemplate(): HTMLTemplateElement {
    //    return document.getElementById("SignUpTemplate") as HTMLTemplateElement;
    //}

    private async loadTemplate(template: HTMLTemplateElement): Promise<HTMLElement> {
        return new Promise<HTMLElement>(async (resolve, reject) => {
            const carousel = this.carousel;
            const container = this.container;
            try {
                const el = template.cloneNode(true) as HTMLElement;

                const carouselItem = $(this.createCarouselItem(el.innerHTML));

                $(this.container).find(".carousel-inner").append(carouselItem);

                this.bindForm(carouselItem[0]);

                setTimeout(async () => {
                    carousel.next();

                    resolve(carouselItem[0]);
                }, 100);

            } catch (error) {
                console.error('Error loading step:' + error);
                carousel.prev();
                reject(error);
            }
        });
    }


    private async loadUrl(url: string): Promise<HTMLElement> {
        
        return new Promise<HTMLElement>(async (resolve, reject) => {
            const carousel = this.carousel;
            const container = this.container;
            try {
                this.reset();

                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    }
                });

                var text = await response.text();

                const carouselItem = $(this.createCarouselItem(text));

                $(this.container).find(".carousel-inner").append(carouselItem);

                this.bindForm(carouselItem[0]);

                const el = carouselItem[0];
                await this.setActiveItem(el);
                //(el.previousSibling as HTMLElement).classList.remove("active");
                //el.classList.add("active");       
                

                setTimeout(async () => {

                    resolve(carouselItem[0]);
                }, 100);

            } catch (error) {
                console.error('Error loading step:' + error);
                carousel.prev();
                reject(error);
            }
        });
    }

    private bindForms() {
        this.onDelegate('submit', '.signin-form', async (event: Event) => {

        });
    }

    private onDelegate(
        eventName: string,
        selector: string,
        callback: (event: Event) => void
    ): void {
        document.addEventListener(eventName, (event: Event) => {
            const target = event.target as HTMLElement;
            if (target.matches(selector)) {
                callback(event);
            }
        });
    }

    private async onSignInResult(result: SignInResult, form?: HTMLFormElement | null): Promise<SignInResult> {
        return new Promise<SignInResult>(async (resolve, reject) => {

            console.log(result);

            if (result.requiresTwoFactor) {
                await this.loadUrl(IdentityEndPoints.TwoFactorSignIn);
                resolve(result);
                return;
            }
            if (result.requiresCustomer) {
                await this.loadUrl(IdentityEndPoints.CustomerSignIn);
                resolve(result);
                return;
            }
            if (result.nextStepUrl) {
                await this.loadUrl(result.nextStepUrl);
                resolve(result);
                return;
            }

            if (result.succeeded) {


                //carouselItem.innerHTML = '<div class="text-success d-flex justify-content-center align-items-center fs-4" style="min-height:189px"><i class="fal fa-check p-1"></i>Login success!</div>';
                //await Task.delay(2000);
                $('#loginModal').modal('hide');
                sessionStorage.setItem("loginDone", "true");
                resolve(result);

                if (this.returnUrl) {
                    window.location.href = this.returnUrl;
                } else {
                    window.location.reload();
                }
                return;
            } else {
                
                
                if (result.errors) {
                    // Créer un objet pour les erreurs à passer à showErrors
                    const errors: { [key: string]: string } = {};
                    result.errors.forEach((error: ValidationError) => {
                        if (error.value.errors.$values.length > 0) {
                            const errorMessages = error.value.errors.$values
                                .map(err => err.errorMessage)
                                .join(", ");
                            errors[error.key] = errorMessages;
                        }
                    });

                    // Afficher les erreurs avec jQuery Validation
                    ($(form).validate() as any).showErrors(errors);

                    // Optionnel : Ajouter une classe CSS aux champs avec erreurs
                    Object.keys(errors).forEach(key => {
                        $(`[name="${key}"]`).addClass("is-invalid");
                    });

                    
                }

                if (result.error != null) {
                    const error = result.error;

                    if (result.error.status === 400 || error.status === 401) {
                        const validator = $(form).validate();
                        const response = error.responseJSON;

                        // Afficher un message d'erreur global
                        const errorMessage = response?.message || 'Erreur de connexion';
                        $(form).find('.validation-summary')?.prepend(`<div class="alert alert-danger alert-dismissible fade show" role="alert">${errorMessage}</div>`);

                        try {
                            if (response && !response.succeeded && response.errors) {
                            // Afficher les erreurs du ModelState
                            
                                const errors: { [key: string]: string[] } = {};
                                Object.keys(response.errors).forEach(key => {
                                    if (key !== '$id') {
                                        errors[key] = response.errors[key];
                                    }
                                });

                                // Supprimer les anciennes erreurs
                                validator.resetForm();

                                validator.showErrors(errors);

                                validator.focusInvalid();
                            } else {
                                // Message d'erreur générique
                                $(form).find('.validation-summary')?.prepend('<div class="text-danger">forbiden</div>');
                                validator.showErrors({
                                    Password: 'Erreur de connexion'
                                });
                                validator.focusInvalid();
                            }
                        }catch (err) {

                        }
                       

                    } else {

                        if (typeof error === 'string') {
                            $(form).find('.validation-summary')?.prepend(`<div class="alert alert-danger alert-dismissible fade show" role="alert">${result.error}</div>`);
                        } else {
                            $(form).find('.validation-summary')?.prepend(`<div class="alert alert-danger alert-dismissible fade show" role="alert">${result.error[""].errors.$values[0].errorMessage}</div>`);
                        }
                        
                        console.error('Error submitting form:${error}', error);
                    }
                    
                }
                else {
                    //await this.loadTemplate(this.errorTemplate);
                }
                
                await this.setActiveItem(form.closest(".carousel-item"));

                //form.closest(".carousel-item").classList.add("active");
                
            }

        });
    }

    private async setActiveItem(carouselItem: HTMLElement)  : Promise<void>{

        return new Promise(resolve => {

            this.carouselItems.forEach(i => {
                i.classList.remove("active");
                i.classList.remove("carousel-item-start");
            });
            carouselItem.classList.add("active");

            $(this.container).one("slid.bs.carousel", ()=>resolve());


        })

    }
     

    private async bindForm(carouselItem: HTMLElement): Promise<void> {
        return new Promise(resolve => {
            const _ = this;

            const form = carouselItem.querySelector('form') as HTMLFormElement;
            const $form = $(form);
            if (!form) return;
            this._currentForm = form;


            const event = new CustomEvent('signInFormLoaded', {
                detail: { form }
            });


            document.dispatchEvent(event);

            $form.find('.validation-summary').empty();

            $form.removeData('validator'); // Supprime les anciens validateurs
            $form.removeData('unobtrusiveValidation'); // Supprime les données unobtrusive

            ($.validator as any).unobtrusive.parse($(form)); // Réapplique la validation

            form.addEventListener('submit', async (e) => {
                e.preventDefault();

                

                if (!$form.valid()) {
                    this._passwordValidator.initialize(form);
                    return;
                }

                // clear errors 
                $('.validation-summary').empty();

                $('.signin-error-message').text('').addClass('d-none');

                const formData = new FormData(form);
                const data = Object.fromEntries(formData.entries() as Iterable<readonly [string, string | File]>);

                var loader = await _.startLoading();

                try {

                    var result = await $.post({ url: form.action, data }) as SignInResult;

                    if (!result.succeeded) $form.find('input[type=password]').val('');  // reset les password du form (on essai de bloquer le gestionnaire de mots de passe du navigateur)

                    loader.remove();                 
                    
                    result = await this.onSignInResult(result, form);
                    

                } catch (error) {
                    loader.remove();
                    await this.onSignInResult({ succeeded: false, error: error }, form);

                }
            });


            resolve();
        });
    }

    private handleFormLoad(form: HTMLFormElement): void {
        console.log('Formulaire chargé !', form);
        $(form).trigger('onload');
        // Ajoutez ici votre logique, par exemple initialisation ou validation
    }

    // Réinitialiser les messages d'erreur
    private clearErrors(form: HTMLFormElement): void {
        const errorElements = form.querySelectorAll('.error-message');
        errorElements.forEach(el => el.remove());
        const fields = form.querySelectorAll('input, select, textarea');
        fields.forEach(field => field.classList.remove('error'));
    }

    // Afficher une erreur pour un champ
    private displayError(field: HTMLInputElement, errorMessage: string[]): void {
        field.classList.add('error');
        const errorElement = document.createElement('div');
        errorElement.className = 'error-message';
        errorElement.textContent = errorMessage.join(', '); // Joindre les messages
        field.parentElement?.appendChild(errorElement);
    }

}


export interface LoginPopupOptions {
    selector: string;
}


export class LoginPopup {
    [x: string]: any;
    private _container: HTMLElement;
    private _carousel: Carousel;


    constructor(options: LoginPopupOptions) {
        this.options = options;

        const _ = this;
        $(function () {

            _._container = document.getElementById("loginBodyContainer");
            _._carousel = new Carousel(_._container, {
                pause: 'hover', ride: false, touch: false, wrap: true, interval: 0
            });
        });

        // Soumission du formulaire de connexion
        $(document).on('submit', options.selector, this.login);

        $(options.selector).prop('LoginPopup', this);

        $('#loginModal').on('shown.bs.modal', function () {
            //_.reset();
        });
    }
    private get container(): HTMLElement {
        return document.getElementById('loginBodyContainer');
    }

    private get carousel(): Carousel {
        return this._carousel ?? (this._carousel = new Carousel(this.container, { ride: false, touch: false, wrap: true, interval: 0 }));
    }

    private async reset(): Promise<void> {
        return new Promise((resolve, reject) => {
            try {
                var items = this.container.querySelectorAll(".carousel-item");

                items.forEach((item, index) => {
                    if (index !== 0) {
                        item.remove(); // Supprimer l'élément
                    }
                });
                items.item(0).classList.add('active');
                this.carousel.next();
                resolve();
            } catch (e) {
                reject(e);
            }
        });
    }

    private login(event: JQueryEventObject) {
 
        var instance = $(this).prop('LoginPopup') as LoginPopup;

        const _ = instance;

        event.preventDefault();
        $('#login-error').hide();
        $('#login-submit').attr('disabled', 'disabled');

        const container = _.container;// document.getElementById("loginBodyContainer");
        const carousel = _.carousel;

        _.loadingStep();

        $.ajax({
            url: '/Account/Login', // URL de votre action de connexion
            type: 'POST',
            data: $(this).serialize(),
            success: function (response) {
                if (response.succeeded) {
                    // Connexion réussie, rediriger
                    window.location.href = response.redirectUrl;
                } else if (response.twoFactorRequired) {

                    if (response.partialResult) {

                        $.post({ url: response.partialResult, method: 'GET' }).then(r => {

                            const carouselInner = container.querySelector('.carousel-inner');
                            const nouvelElement = document.createElement('div');
                            nouvelElement.classList.add('carousel-item');

                            nouvelElement.innerHTML = r;

                            // Ajouter le nouvel élément
                            carouselInner.appendChild(nouvelElement);

                            // Optionnel : rendre le nouvel élément actif
                            //container.querySelector('.carousel-item.active').classList.remove('active');
                            //nouvelElement.classList.add('active');
                            const currentElement = container.querySelector(".courousel-item.active");

                            if (currentElement != null) {
                                nouvelElement.style.minHeight = currentElement.clientHeight.toString();
                            }

                            setTimeout(() => _.carousel.next(), 100);

                            const otp = new TwoFactorInputManager({
                                containerSelector: ".pinCodeContainer",
                                verifyFunctionHandler: function (code) {
                                    //$('input[type=hidden][name=Token]').val(code);

                                    //alert("je vais check le code");
                                    $.post({ url: IdentityEndPoints.TwoFactorSignIn, data: { Token: code } })
                                        .then(twoFactorVerif => {

                                           
                                        }).catch(err => {
                                            alert(err);
                                        });

                                    //$('input[type=hidden][name=Token]').closest('form').submit();
                                }
                            });

                        });

                    }


                } else {
                    // Afficher l'erreur
                    $('#login-error').text(response.error || 'Erreur de connexion.').show();

                }
            },
            error: function () {
                $('#login-error').text('Une erreur est survenue.').show();
            }
        });
    }

    private async addStep(contentHTML: string): Promise<void> {
        const _ = this;
        const container = _.container;// document.getElementById("loginBodyContainer");
        const carousel = _.carousel;

        return new Promise((resolve, reject) => {

            const carouselInner = container.querySelector('.carousel-inner');
            const nouvelElement = document.createElement('div');
            nouvelElement.classList.add('carousel-item');
            nouvelElement.innerHTML = contentHTML;

            // Ajouter le nouvel élément
            carouselInner.appendChild(nouvelElement);

            // Optionnel : rendre le nouvel élément actif
            //container.querySelector('.carousel-item.active').classList.remove('active');
            //nouvelElement.classList.add('active');
            const currentElement = container.querySelector(".courousel-item.active");

            if (currentElement != null) {
                nouvelElement.style.minHeight = currentElement.clientHeight.toString();
            }

            setTimeout(() => {
                _.carousel.next();
                resolve();
            }, 1);
        });
    }

    private async loadingStep(): Promise<void> {
        const _ = this;
        const container = _.container;// document.getElementById("loginBodyContainer");
        const carousel = _.carousel;
        return new Promise((resolve, reject) => {


            const carouselInner = container.querySelector('.carousel-inner');
            const nouvelElement = document.createElement('div');
            nouvelElement.classList.add('carousel-item');
            nouvelElement.innerHTML = "<div class='d-flex h-100 w-100 justify-content-center align-items-center' style='min-height:289px;'><div class='spinner-grow' role='status' ><span class='visually-hidden'> Loading...</span></div></div>";

            // Ajouter le nouvel élément
            carouselInner.appendChild(nouvelElement);

            // Optionnel : rendre le nouvel élément actif
            //container.querySelector('.carousel-item.active').classList.remove('active');
            //nouvelElement.classList.add('active');
            const currentElement = container.querySelector(".courousel-item.active");

            if (currentElement != null) {
                nouvelElement.style.minHeight = currentElement.clientHeight.toString();
            }

            setTimeout(() => {
                _.carousel.next();
                resolve();
            }, 1);
        });

    }
    private mfaLogin(e: { preventDefault: () => void; }) {

        const otp = this.otp;
        e.preventDefault();
        $('#mfa-error').hide();

        $.ajax({
            url: '/Account/VerifyMfa', // URL de votre action de vérification MFA
            type: 'POST',
            data: $(this).serialize(),
            success: function (response) {
                if (response.succeeded) {
                    // MFA validé, rediriger
                    window.location.href = response.redirectUrl;
                } else {
                    // Afficher l'erreur
                    $('#mfa-error').text(response.error || 'Code MFA incorrect.').show();
                }
            },
            error: function () {
                $('#mfa-error').text('Une erreur est survenue.').show();
            }
        });
    }

    open() {
        // Open the login popup
        console.log("Opening login popup...");
    };


} 

window.SignInManager = SignInManager;
const signInManager = new SignInManager("loginBodyContainer");
window["signInManager"] = signInManager;

